import { Component, ViewChild, OnInit, Input, OnChanges, EventEmitter, Output } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";


@Component({
  selector: 'app-table-mat',
  templateUrl: './table-mat.component.html'
})
export class TableMatComponent implements OnInit, OnChanges {
  @Input() tableData!: any[];
  @Input() pageSize: number = 15;
  @Input() length!: number;
  @Input() pageSizeOptions: number[] = [10,100, 500];
  @Input() pageIndex!: number;
  @Input() columns!: any[];
  @Output() paginationEvent = new EventEmitter<any>();

  /* this code will help you to refresh pagination  */
  private paginator!: MatPaginator;
  private sort!: MatSort;
  @ViewChild(MatSort, {
    static: false
  }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setPaginationAndSort();
  }
  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    // this.setPaginationAndSort();
  }

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.processingData();
  }

  processingData() {
    this.displayedColumns = this.columns.map(c => c.columnDef);
    this.dataSource = new MatTableDataSource(this.tableData);
    this.setPaginationAndSort();
  }

  setPaginationAndSort() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAll(event: any) {
    this.paginationEvent.emit(event);
  }
}
